import { useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useField } from 'formik';
import styled from 'styled-components';
import { useDeepCompareEffect } from 'react-use';
import { KoobInputText, KoobTableAction } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  position: relative;
`;

const ButtonSlot = styled.span`
  position: absolute;
  right: ${({ theme }) => theme.spacing(0.25)};
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`;

const GalleryItemFileNameField = ({ name, onBlur, isEditing }, ref) => {
  const { t } = useTranslation();
  const [field, , { setValue }] = useField({ name });
  const [previousValue, setPreviousValue] = useState(field.value);
  const inputRef = useRef();
  const wrapperRef = useRef();

  const handleCancel = () => {
    setValue(previousValue);
    onBlur();
  };

  const handleBlur = (e) => {
    if (Boolean(e)) {
      e.preventDefault();
    }

    if (field.value === '') {
      handleCancel();
      return;
    }

    setPreviousValue(field.value);
    onBlur();
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      e.stopPropagation();
      handleCancel();
      return;
    }
    if (e.keyCode === 13) {
      e.stopPropagation();
      handleBlur();
      return;
    }
  };

  useImperativeHandle(ref, () => ({
    blur: () => {
      handleCancel();
    },
  }));

  useDeepCompareEffect(() => {
    if (isEditing) {
      try {
        inputRef.current.focus();
        inputRef.current.select();
        setPreviousValue(field.value);
      } catch (err) {
        console.error(err.message);
      }
    }
  }, [{ isEditing }]);

  return (
    <Wrapper ref={wrapperRef}>
      <KoobInputText
        {...field}
        ref={inputRef}
        size="sm"
        disabled={!isEditing}
        onKeyDown={handleKeyDown}
        style={
          isEditing
            ? { paddingRight: 32 }
            : {
                border: 0,
                backgroundColor: 'transparent',
                boxShadow: 'none',
                opacity: 1,
                cursor: 'initial',
              }
        }
      />
      {isEditing && (
        <ButtonSlot>
          <KoobTableAction
            icon={<i className="fa-light fa-arrow-right" />}
            label={t('misc:save')}
            onClick={handleBlur}
          />
        </ButtonSlot>
      )}
    </Wrapper>
  );
};

export default forwardRef(GalleryItemFileNameField);
